import React from "react";
import { getSessionButtonText, getVoucherUpgradeDetails } from "@utils/ticketUtils";


const formatPrice = (cents) => `$${(cents / 100).toFixed(2)}`;

const SessionSummary = ({ purchasedSession, purchasedTicket, formattedDate, formattedTime }) => {
    const ticketQuantity = purchasedTicket?.items?.find((item) => item.session_id != null)?.quantity || 0;

    const upgradeDetails = purchasedSession ? getVoucherUpgradeDetails(purchasedSession) : null;
    const upgradeFeeCents = upgradeDetails ? upgradeDetails.fee * 100 * ticketQuantity : 0;
    const netSavings = purchasedTicket.saving - upgradeFeeCents;

    return (
        <>
            <div className="confirmation__section">
                <p className="paragraph">
                    When: {formattedDate} <br />
                    Time: {formattedTime} <br />
                    Where: {purchasedSession.venue_name},{" "}
                    {purchasedSession.venue_address},{" "}
                    {purchasedSession.venue_suburb}
                    <br />
                    Session Type: {getSessionButtonText(purchasedSession)}
                    <br />
                    Ticket: {purchasedTicket.id}
                </p>
            </div>

            <div className="confirmation__section">
                <p className="paragraph">
                    Price: {formatPrice(purchasedTicket.total_price_cents)} <br />
                    RRP: {formatPrice(purchasedTicket.total_rrp_pricing)} <br />
                    Savings: {formatPrice(netSavings)}
                    {upgradeDetails?.fee > 0 && (
                        <>
                            {" "}(after {formatPrice(upgradeDetails.fee * 100)} x {ticketQuantity} upgrade fee)
                        </>
                    )}
                </p>
            </div>
        </>
    );
};

export default SessionSummary;
